export default "__VITE_ASSET__YPoIYEPU__"